import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../layouts/Layout';
import { AuthContext } from '../../AuthContext';
import {
  FiUsers,
  FiSettings,
  FiPackage,
  FiClipboard,
  FiInbox,
  FiFileText,
  FiTrendingUp,
  FiActivity,
} from 'react-icons/fi';
import './Dashboard.css';
import { apiFetch } from '../../api';

export default function Dashboard() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardCounts();
  }, []);

  const fetchDashboardCounts = async () => {
    try {
      const res = await apiFetch('/api/dashboard/counts');
      const data = res?.data || res || {};
      setCounts(data);
    } catch (err) {
      console.error('Failed to load dashboard counts', err);
      setCounts({});
    } finally {
      setLoading(false);
    }
  };

  const modules = [
    {
      title: 'User Management',
      path: '/users',
      icon: <FiUsers />,
      key: 'users',
      color: '#3b82f6',
      bgColor: '#dbeafe',
      description: 'Manage system users'
    },
    {
      title: 'Item Master',
      path: '/products',
      icon: <FiSettings />,
      key: 'materials',
      color: '#8b5cf6',
      bgColor: '#ede9fe',
      description: 'Manage inventory items'
    },
    {
      title: 'Packaging Slip',
      path: '/packagin-index',
      icon: <FiPackage />,
      key: 'packaging_slip',
      color: '#10b981',
      bgColor: '#d1fae5',
      description: 'Dispatch & packaging'
    },
    {
      title: 'Material Issue Note',
      path: '/material-issue-index',
      icon: <FiClipboard />,
      key: 'material_issue',
      color: '#f59e0b',
      bgColor: '#fef3c7',
      description: 'Issue materials'
    },
    {
      title: 'Material Receipt Note',
      path: '/material-return-index',
      icon: <FiInbox />,
      key: 'material_receipt',
      color: '#06b6d4',
      bgColor: '#cffafe',
      description: 'Receive materials'
    },
    {
      title: 'Test Certificate',
      path: '/test-certificate-index',
      icon: <FiFileText />,
      key: 'test_certificate',
      color: '#ec4899',
      bgColor: '#fce7f3',
      description: 'Quality certificates'
    }
  ];

  // Calculate total records
  const totalRecords = Object.values(counts).reduce((sum, count) => sum + (count || 0), 0);

  return (
    <Layout>
      <div className="dashboard-container">
        {/* Header Section */}
        <div className="dashboard-header">
          <div className="header-content">
            <h1 className="dashboard-title">Dashboard</h1>
            <p className="dashboard-subtitle">
              Welcome back, <span className="username">{user?.username}</span>
            </p>
          </div>
          <div className="header-date">
            {new Date().toLocaleDateString('en-US', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </div>
        </div>

        {/* Summary Cards */}
        {/* <div className="summary-cards">
          <div className="summary-card summary-card-primary">
            <div className="summary-icon">
              <FiActivity />
            </div>
            <div className="summary-content">
              <p className="summary-label">Total Records</p>
              <h2 className="summary-value">{loading ? '...' : totalRecords}</h2>
            </div>
          </div>

          <div className="summary-card summary-card-success">
            <div className="summary-icon">
              <FiPackage />
            </div>
            <div className="summary-content">
              <p className="summary-label">Packaging Slips</p>
              <h2 className="summary-value">{loading ? '...' : counts.packaging_slip || 0}</h2>
            </div>
          </div>

          <div className="summary-card summary-card-warning">
            <div className="summary-icon">
              <FiClipboard />
            </div>
            <div className="summary-content">
              <p className="summary-label">Material Issues</p>
              <h2 className="summary-value">{loading ? '...' : counts.material_issue || 0}</h2>
            </div>
          </div>

          <div className="summary-card summary-card-info">
            <div className="summary-icon">
              <FiFileText />
            </div>
            <div className="summary-content">
              <p className="summary-label">Test Certificates</p>
              <h2 className="summary-value">{loading ? '...' : counts.test_certificate || 0}</h2>
            </div>
          </div>
        </div> */}

        {/* Modules Section */}
        <div className="modules-section">
          <div className="section-header">
            <h2 className="section-title">Quick Access</h2>
            <p className="section-subtitle">Navigate to different modules</p>
          </div>

          <div className="modules-grid">
            {modules.map((module, index) => (
              <div
                key={index}
                className="module-card"
                onClick={() => navigate(module.path)}
                style={{
                  '--module-color': module.color,
                  '--module-bg': module.bgColor,
                }}
              >
                <div className="module-icon" style={{ backgroundColor: module.bgColor, color: module.color }}>
                  {module.icon}
                </div>

                <div className="module-content">
                  <h3 className="module-title">{module.title}</h3>
                  <p className="module-description">{module.description}</p>

                  <div className="module-footer">
                    <div className="module-count" style={{ color: module.color }}>
                      {loading ? '...' : counts[module.key] || 0}
                      <span className="count-label">records</span>
                    </div>
                    <div className="module-arrow" style={{ color: module.color }}>→</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
